import React from 'react';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface Certification {
  name: string;
  icon: string;
}

interface ClientLogo {
  name: string;
  logo: string;
  alt: string;
}

const TrustSignals = () => {
  const certifications: Certification[] = [
  { name: 'BBB A+ Rated', icon: 'ShieldCheckIcon' },
  { name: 'Licensed & Bonded', icon: 'DocumentCheckIcon' },
  { name: 'Insured Transactions', icon: 'LockClosedIcon' },
  { name: 'Industry Certified', icon: 'StarIcon' }];


  const clientLogos: ClientLogo[] = [
  {
    name: 'Enterprise Logistics',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1cf69b36c-1767868422568.png",
    alt: 'Enterprise Logistics company logo with blue and white corporate branding'
  },
  {
    name: 'National Transport Co',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_18027e3cd-1767868425051.png",
    alt: 'National Transport Company logo featuring red truck icon and bold typography'
  },
  {
    name: 'Metro Delivery Services',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_19af0fb09-1767868424323.png",
    alt: 'Metro Delivery Services logo with green and orange color scheme'
  },
  {
    name: 'Regional Fleet Solutions',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1b15d066e-1767868423647.png",
    alt: 'Regional Fleet Solutions corporate logo with modern geometric design'
  }];


  return (
    <section className="bg-card py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        {/* Certifications */}
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-8">
            Trusted & Certified
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {certifications.map((cert, index) =>
            <div
              key={index}
              className="flex flex-col items-center space-y-3 p-6 bg-background rounded-lg hover:shadow-brand transition-all duration-200">

                <div className="p-3 bg-primary/10 rounded-full">
                  <Icon name={cert.icon as any} size={32} variant="solid" className="text-primary" />
                </div>
                <p className="text-sm font-semibold text-foreground text-center">{cert.name}</p>
              </div>
            )}
          </div>
        </div>

        {/* Client Logos */}
        <div className="border-t border-border pt-12">
          <p className="text-center text-sm font-medium text-muted-foreground mb-8">
            TRUSTED BY LEADING FLEET OPERATORS
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 items-center">
            {clientLogos.map((client, index) =>
            <div
              key={index}
              className="flex items-center justify-center p-4 bg-background rounded-lg hover:shadow-md transition-all duration-200 grayscale hover:grayscale-0">

                <AppImage
                src={client.logo}
                alt={client.alt}
                className="w-full h-16 object-contain" />

              </div>
            )}
          </div>
        </div>

        {/* Stats Bar */}
        <div className="mt-12 bg-primary rounded-2xl p-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {[
            { value: '500+', label: 'Fleet Clients Served' },
            { value: '2,500+', label: 'Vehicles Purchased' },
            { value: '$45M+', label: 'Total Value Processed' },
            { value: '98%', label: 'Client Satisfaction' }].
            map((stat, index) =>
            <div key={index} className="text-center">
                <p className="text-3xl md:text-4xl font-bold text-accent mb-2">{stat.value}</p>
                <p className="text-sm text-primary-foreground/80">{stat.label}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>);

};

export default TrustSignals;